import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useAuth, isAdminUser } from '../hooks/useAuth';
import CollapsibleHelpSection from '../components/common/CollapsibleHelpSection';
import KensukeFeatureGrid from '../components/home/KensukeFeatureGrid';
import KensukeAiContentSection from '../components/home/KensukeAiContentSection';
import DashboardFeatureRequests from '../components/home/DashboardFeatureRequests';
import surface from '../components/home/KensukeSurface.module.scss';

export default function Dashboard() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isAdmin = isAdminUser(user);

  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
    user?.username ||
    user?.email ||
    '';

  const pageTitle = `${t('dashboard.title', { defaultValue: 'ダッシュボード' })} | kensuke-system`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <section className={`${surface.hero} ${surface.dashboardHero}`} aria-labelledby="dashboard-hero-heading">
        <Container>
          <div className={surface.heroInner}>
            <div className={surface.heroAccent} aria-hidden />
            <div>
              <p className={surface.heroTagline}>
                {t('dashboard.title', { defaultValue: 'ダッシュボード' })}
              </p>
              <h1 id="dashboard-hero-heading" className={surface.heroTitle}>
                {displayName
                  ? t('dashboard.welcome_named', {
                      defaultValue: '{{name}} さん',
                      name: displayName,
                    })
                  : t('dashboard.title', { defaultValue: 'ダッシュボード' })}
              </h1>
              <p className={surface.heroLead}>
                {t('dashboard.workspace_lead', {
                  defaultValue: '使いたいツールを開いて作業を続けてください。',
                })}
              </p>
            </div>
          </div>
        </Container>
      </section>

      <KensukeAiContentSection surface="dashboard" isLoggedIn isAdmin={isAdmin} />

      <section id="features" className={surface.section} aria-labelledby="dashboard-features-heading">
        <Container>
          <h2 id="dashboard-features-heading" className={`${surface.sectionHeading} mb-3`}>
            {t('home.features_title', { defaultValue: 'ツール一覧' })}
          </h2>
          <KensukeFeatureGrid surface="dashboard" isLoggedIn isAdmin={isAdmin} group="tool" />
        </Container>
      </section>

      <DashboardFeatureRequests />

      <section className="py-4 bg-white border-top">
        <Container>
          <CollapsibleHelpSection
            titleKey="dashboard.how_to_use_title"
            descriptionKey="dashboard.how_to_use_desc"
            stepsKey={[
              'dashboard.how_to_use_step1',
              'dashboard.how_to_use_step2',
              'dashboard.how_to_use_step3',
              'dashboard.how_to_use_step4',
            ]}
            storageKey="dashboard"
          />
        </Container>
      </section>
    </>
  );
}
